import React, { lazy } from "react";
import Loadable from "./Loadable";
import DashboardLayout from "../dashboard/Dashboard";

const HomeDashboard = Loadable(
  lazy(() => import("../dashboard/HomeDashboard"))
);
const ContactUs = Loadable(lazy(() => import("../contact/Contact")));
const Career = Loadable(lazy(() => import("../CareerPage/CareerPage")));
const About = Loadable(lazy(() => import("../about/About")));
const Service = Loadable(lazy(() => import("../service/Service")));

const routes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      { index: true, element: <HomeDashboard /> },
      { path: "home", element: <HomeDashboard /> },
      { path: "services", element: <Service /> },
      { path: "careers", element: <Career /> },
      { path: "contact", element: <ContactUs /> },
      { path: "about", element: <About /> },
    ],
  },
];

export default routes;
